// htmlStringToArr :: String -> String -> [Element]
export const htmlStringToChildren = selector => string => {
  const div = document.createElement('div');
  div.innerHTML = string.trim();

  const target = selector ? div.querySelectorAll(selector) : div.children;

  return Array.from(target);
};
